import React, { useState, useEffect } from "react";

const TimeDisplay = ({ timezone }) => {
  const [currentTime, setCurrentTime] = useState("");
  const [timezoneOffset, setTimezoneOffset] = useState("");
  const [localTimezone, setLocalTimezone] = useState(
    timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
  );

  useEffect(() => {
    setLocalTimezone(
      timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
    );
  }, [timezone]);

  const updateTime = () => {
    const now = new Date();
    // Get the formatted time in the specified timezone
    const timeInTimezone = now.toLocaleString("en-US", {
      timeZone: localTimezone,
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      year: "numeric",
      month: "short",
      day: "numeric",
    });

    // Calculate the GMT offset for the timezone
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: localTimezone,
      timeZoneName: "short",
    });
    const parts = formatter.formatToParts(now);
    const timeZoneName =
      parts.find((part) => part.type === "timeZoneName")?.value || "";
    const gmtOffset =
      now
        .toLocaleString("en-US", {
          timeZone: localTimezone,
          timeZoneName: "shortOffset",
        })
        .match(/GMT([+\-]\d+)/)?.[0] || "";

    setCurrentTime(timeInTimezone);
    setTimezoneOffset(`${gmtOffset} ${localTimezone}`);
  };

  useEffect(() => {
    updateTime(); // Initial time update
    const interval = setInterval(updateTime, 1000); // Update every second
    return () => clearInterval(interval); // Clean up on unmount
  }, [localTimezone]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      {timezone ? (
        <span style={{ fontSize: "12px", fontWeight: "bold" }}>
          Project Time
        </span>
      ) : (
        <span style={{ fontSize: "12px", fontWeight: "bold" }}>Local Time</span>
      )}
      <span style={{ fontSize: "10px" }}>{currentTime}</span>
      <span style={{ fontSize: "10px" }}> ({timezoneOffset})</span>
    </div>
  );
};

export default TimeDisplay;
